import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  centrosCustos: [],
  solicitantes: [],
  produto: [],
  projeto: [],
  searchText: null,
  empresa: null,
  grupo: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
